import libphonenumber from "google-libphonenumber";

export function isEmptyString(string) {
  return (
    string === null ||
    string === undefined ||
    string === "" ||
    string.length === 0
  );
}

export function isValidURL(url) {
  var regex = new RegExp(
    /^(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})$/
  );
  return regex.test(url);
}

export function isValidPhoneNumber(phoneNumber) {
  if (isEmptyString(phoneNumber)) return false;
  else {
    const PhoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
    const region = "AR";
    const number = PhoneUtil.parseAndKeepRawInput(phoneNumber, region);
    return PhoneUtil.isValidNumberForRegion(number, region);
  }
}

export function isValidLocation(location) {
  if (!location.match(/^[-]?\d+[\.]?\d*, [-]?\d+[\.]?\d*$/)) {
    return false;
  }
  const [latitude, longitude] = location.split(",");
  return latitude > -90 && latitude < 90 && longitude > -180 && longitude < 180;
}
